import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-950 text-center p-6"
      data-testid="not-found-page"
    >
      <Compass className="w-10 h-10 text-amber-500" />
      <h1 className="text-2xl font-bold text-slate-100">Page not found</h1>
      <p className="text-sm text-slate-400 max-w-sm">
        This page doesn't exist. Head back to your dashboard.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="px-4 py-2 rounded-lg bg-amber-500 hover:bg-amber-400 text-slate-950 text-sm font-medium transition-colors"
      >
        Back to Dashboard
      </Link>
    </div>
  );
}
